var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCovCode = function SvgCovCode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134.699,
    height: 108.032,
    viewBox: "0 0 134.699 108.032",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-713.512 -104.135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.9-.9H133.8V107.132H-.9ZM132,.9H.9V105.332H132Z",
    transform: "translate(714.412 105.035)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.718.9H-.9V-.9H119.718Z",
    transform: "translate(714.412 119.713)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.791.9H0V-.9H4.791Z",
    transform: "translate(722.751 112.455)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.791.9H0V-.9H4.791Z",
    transform: "translate(732.333 112.455)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.791.9H0V-.9H4.791Z",
    transform: "translate(741.914 112.455)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.272.9H-.9V-.9H15.272Z",
    transform: "translate(729.302 134.34)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.873.9H-.9V-.9H21.873Z",
    transform: "translate(729.302 159.508)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.881.9H-.9V-.9H9.881Z",
    transform: "translate(765.71 184.676)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.855.9H-.9V-.9H26.855Z",
    transform: "translate(729.302 197.26)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.355.9H-.9V-.9H10.355Z",
    transform: "translate(729.302 146.924)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.355.9H-.9V-.9H10.355Z",
    transform: "translate(760.982 159.508)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.782.9H-.9V-.9H4.782Z",
    transform: "translate(749.505 146.924)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.355.9H-.9V-.9H10.355Z",
    transform: "translate(729.302 184.676)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.782.9H-.9V-.9H4.782Z",
    transform: "translate(750.275 184.676)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.782.9H-.9V-.9H4.782Z",
    transform: "translate(765.71 197.26)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.18.9H-.9V-.9H17.18Z",
    transform: "translate(744.702 172.092)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.782.9H-.9V-.9H4.782Z",
    transform: "translate(729.302 172.092)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.872,157.956,754.689,147.1l9.183-10.859,1.374,1.162-8.2,9.7,8.2,9.7Z",
    transform: "translate(31.507 24.678)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.61,157.956l-1.374-1.162,8.2-9.7-8.2-9.7,1.374-1.162,9.183,10.859Z",
    transform: "translate(46.431 24.678)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.554,25.678l-1.7-.591L7.978-1.146l1.7.591Z",
    transform: "translate(804.444 159.508)",
    fill: "#5680e9"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCovCode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cov-code.0c8b226d.svg";
export { ForwardRef as ReactComponent };